import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export const useControlledComponentState = (updateParentProp, stateFromParent) => {
  const [localState, setLocalState] = useState(stateFromParent);
  const lastProps = useRef({});
  useEffect(() => {
    if (stateFromParent !== lastProps.current) {
      lastProps.current = stateFromParent;
      setLocalState(stateFromParent);
    }
  }, [stateFromParent]);
  const updateParent = useCallback(
    (newLocalState) => {
      if (newLocalState !== undefined) {
        // Not resetting ref so that it can be memoized via props
        setLocalState(newLocalState);
        updateParentProp(newLocalState);
        return;
      }
      updateParentProp(localState);
    },
    [localState, updateParentProp],
  );
  return useMemo(() => {
    return { localState, setLocalState, updateParent };
  }, [localState, updateParent]);
};

export const useControlledState = (value) => {
  const [localState, setLocalState] = useState(value);
  useEffect(() => {
    setLocalState(value);
  }, [value, setLocalState]);

  return [localState, setLocalState];
};
